module.exports = __webpack_public_path__ + "img/record_on.aec7731e.svg";